<section class="mat-typography mat-body component-container">
  <p class="heading">Required Tags <span>(* required)</span></p>

  <form [formGroup]="requiredTagsForm" (submit)="checkRetrievalTags()">

    @for (tag of configuration.retrievalTags; track tag) {
      <div>
        @switch (tag.type) {
          <!-- Radio Group -->
          @case ('radio') {
            <div>
              <mat-label>{{ tag.label }}*</mat-label>
              <mat-radio-group [formControlName]="tag.label" (change)="!manuallyTriggeredSearch && checkRetrievalTags()">
                @for (option of tag.options | subordinateFilter; track trackByIndex($index, option)) {
                  <mat-radio-button [value]="option.value">
                    {{ option.label }}
                  </mat-radio-button>
                }
              </mat-radio-group>
            </div>
          }
          <!-- Selection-List -->
          @case ('selection-list') {
            <div>
              <mat-label>{{ tag.label }}*</mat-label>
              <mat-selection-list [formControlName]="tag.label" (selectionChange)="!manuallyTriggeredSearch && checkRetrievalTags()" [compareWith]="compareWithFn">
                @for (option of tag.options | subordinateFilter; track option) {
                  <mat-list-option [value]="option.value">
                    {{ option.label }}
                  </mat-list-option>
                }
              </mat-selection-list>
            </div>
          }
          <!-- Multi-Checkbox -->
          @case ('multi-checkbox') {
            <div>
              <mat-label>{{ tag.label }}*</mat-label>
              <div class="checkbox-container">
                @for (option of tag.options | subordinateFilter; track trackByIndex($index, option)) {
                  <mat-checkbox (change)="updateCheckboxList(option.value, tag, requiredTagsForm) && !manuallyTriggeredSearch && checkRetrievalTags()">
                    {{ option.label }}
                  </mat-checkbox>
                }
              </div>
            </div>
          }
          <!-- Select -->
          @case ('select') {
            <div>
              <mat-form-field appearance="outline">
                <mat-label>{{ tag.label }}*</mat-label>
                <mat-select [formControlName]="tag.label" (selectionChange)="!manuallyTriggeredSearch && checkRetrievalTags()" [compareWith]="compareWithFn">
                  @for (option of tag.options | subordinateFilter; track option) {
                    <mat-option [value]="option.value">{{ option.label }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }
          <!-- Multi-Select -->
          @case ('multi-select') {
            <div>
              <mat-form-field appearance="outline">
                <mat-label>{{ tag.label }}*</mat-label>
                <mat-select [formControlName]="tag.label" (selectionChange)="!manuallyTriggeredSearch && checkRetrievalTags()" [compareWith]="compareWithFn" multiple>
                  @for (option of tag.options | subordinateFilter; track option) {
                    <mat-option [value]="option.value">{{ option.label }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }
          <!-- Other input types -->
          <!-- Add code to render other input types based on your requirements -->
        }
        @if (requiredTagsFormControls[tag.label].errors?.required && formSubmissionAttempted) {
          <mat-error>
            Required
          </mat-error>
        }
      </div>
    }

    <button #hiddenSubmit type="submit"></button>

  </form>

  @if (manuallyTriggeredSearch) {
    <div>
      <button class="search-button" mat-raised-button color="primary" type="button" (click)="hiddenSubmit.click()">Search</button>
    </div>
  }

  <br />

  @if (dataSource && dataSource.data) {
    @if (displayFilterTags) {
      <p class="heading">Filter Tags <span>(<a href="javascript:void(0)" (click)="filterTagsForm.reset()">reset</a>)</span></p>
      <form [formGroup]="filterTagsForm">
        @for (tag of configuration.filterTags; track tag; let i = $index) {
          <div>
            @if ((
              !tag.subordinateTo || isSubordinateTagVisible(tag) && filterTagsFormValues[tag.subordinateTo] && filterTagsFormValues[tag.subordinateTo].length > 0
              ) && hasValuesToDisplay(tag)) {
              @switch (tag.type) {
                <!-- Radio Group -->
                @case ('radio') {
                  <div>
                    <mat-label>{{ tag.label }}</mat-label>
                    <mat-radio-group [formControlName]="tag.label" (change)="onFilterChange(tag, i)">
                      @for (option of tag.options | subordinateFilter; track trackByIndex($index, option)) {
                        <mat-radio-button [value]="option.value">
                          {{ option.label }}
                        </mat-radio-button>
                      }
                    </mat-radio-group>
                  </div>
                }
                <!-- Selection-List -->
                @case ('selection-list') {
                  <div>
                    <mat-label>{{ tag.label }}</mat-label>
                    <mat-selection-list [formControlName]="tag.label" (selectionChange)="onFilterChange(tag, i)" [compareWith]="compareWithFn">
                      @for (option of tag.options | subordinateFilter; track option) {
                        <mat-list-option [value]="option.value">
                          {{ option.label }}
                        </mat-list-option>
                      }
                    </mat-selection-list>
                  </div>
                }
                <!-- Multi-Checkbox -->
                @case ('multi-checkbox') {
                  <div>
                    <mat-label>{{ tag.label }}</mat-label>
                    <div class="checkbox-container">
                      @for (option of tag.options | subordinateFilter; track trackByIndex($index, option)) {
                        <mat-checkbox (change)="updateCheckboxList(option.value, tag, filterTagsForm) && onFilterChange(tag, i)">
                          {{ option.label }}
                        </mat-checkbox>
                      }
                    </div>
                  </div>
                }
                <!-- Select -->
                @case ('select') {
                  <div>
                    <mat-form-field appearance="outline">
                      <mat-label>{{ tag.label }}</mat-label>
                      <mat-select [formControlName]="tag.label" (selectionChange)="onFilterChange(tag, i)" [compareWith]="compareWithFn">
                        @for (option of tag.options | subordinateFilter; track option) {
                          <mat-option [value]="option.value">{{ option.label }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                }
                <!-- Multi-Select -->
                @case ('multi-select') {
                  <div>
                    <mat-form-field appearance="outline">
                      <mat-label>{{ tag.label }}</mat-label>
                      <mat-select [formControlName]="tag.label" (selectionChange)="onFilterChange(tag, i)" [compareWith]="compareWithFn" multiple>
                        @for (option of tag.options | subordinateFilter; track option) {
                          <mat-option [value]="option.value">{{ option.label }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                }
                <!-- Other input types -->
                <!-- Add code to render other input types based on your requirements -->
              }
            }
          </div>
        }
      </form>
    }
    <!-- Document Table -->
    <div [hidden]="!dataSource" class="table-container">
      <p class="heading">Filter by Filename</p>
      <!-- File Search -->
      <form [formGroup]="textFilterForm">
        <mat-form-field class="search-input" floatLabel="never">
          <!-- <mat-label>Search for a file</mat-label> -->
          <input type="text" matInput [formControlName]="'fileSearch'" [placeholder]="'Search for a file'" />
          @if (textFilterFormValues.fileSearch?.length < textFilterFormMinimumReqs.length) {
            <mat-error>
              You must enter at least {{textFilterFormMinimumReqs}} characters
            </mat-error>
          }
        </mat-form-field>
      </form>
      <mat-table mat-table matSort class="mat-elevation-z6" [dataSource]="dataSource">
        <ng-container matColumnDef="fileName">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            <span>Document</span>
          </mat-header-cell>
          <mat-cell *matCellDef="let document">
            <a href="javascript:void(0);" class="no-text-decor" (click)="saveDocument(document)">
              <span class="bold-title">
                {{document.fileName}}
              </span>
            </a>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="download">
          <mat-header-cell *matHeaderCellDef>
            <span>Download</span>
          </mat-header-cell>
          <mat-cell *matCellDef="let document">
            <a href="javascript:void(0);" class="light-padding" (click)="saveDocument(document)">
              <span class="material-symbols-outlined">save_alt</span>
            </a>
          </mat-cell>
        </ng-container>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="9999">
            No data matching the filter
          </td>
        </tr>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>
      <!-- Paginator -->
      <mat-paginator #AemDocumentSearchPaginator [length]="dataSource && dataSource.data && dataSource.data.length" [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    </div>
  }
</section>
